import { wrapperBuilder } from './build';

const functionsRegister = wrapperBuilder.getFunctionsRegisterInstance();

functionsRegister.addFunction('setStyles', wrapperEnvironment => val => {
  wrapperEnvironment.variablesHandler.variablesSetter('styles')(val);
  console.log(' SHOWINT BINDED ', wrapperEnvironment.bindedContexts.name);
});
